import { render, staticRenderFns } from "./UserCalendars.vue?vue&type=template&id=37723eee"
import script from "./UserCalendars.vue?vue&type=script&lang=js"
export * from "./UserCalendars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports